import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";
import config from "../../config";
import { RandomId } from "../../Utils/RandomId";
import { UploadFiles, base64toFile, renameFile } from "../../Utils/UploadFile";
import { encryptFileAES } from "../../Utils/OstreonEncryption";
import { UserData } from "../../Context/DataContext";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { sendUIErrorToBackend } from "../../Utils/sendErrorToBackend";
import { useAuth } from "../../Context/AuthContext";
import { detectRedirectionPage, prepareUserFetch } from "../../Utils/prepareUserFetch";
const base_url = config?.base_url;

function PrepareUser({}) {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const authData = useAuth();
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const location = useLocation();
  const navigate = useNavigate();
  if (!location?.state?.prepare) navigate("/logout", { replace: true });
  const userData = UserData();
  useEffect(() => {
    if (!location?.state?.prepare) return;
    return prepareUserFetch(
      ()=>{detectRedirectionPage(authData)},
      userData,
      ()=>{window.location.assign(`${window?.location?.protocol}//${window?.location?.host}/user/dashboard`)}
    )
  }, []);
  // if (!location?.state?.prepare) {return navigate('/logout', {replace:true})}
  return (
    <div
      style={{
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        position: "fixed",
        zIndex: "10000",
        height: "100vh",
        width: "100vw",
        backgroundColor: "white",
        opacity: 1,
      }}
    >
      <Loading text={dublicatedcontent.dublicatedText257} />
    </div>
  );
}
export default PrepareUser;
